import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const BeneficiaryList = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M13.64 11.2C13.9318 11.2 14.2116 11.0841 14.4179 10.8778C14.6241 10.6715 14.74 10.3917 14.74 10.1C14.74 9.80826 14.6241 9.52847 14.4179 9.32218C14.2116 9.11589 13.9318 9 13.64 9C13.3483 9 13.0685 9.11589 12.8622 9.32218C12.6559 9.52847 12.54 9.80826 12.54 10.1C12.54 10.3917 12.6559 10.6715 12.8622 10.8778C13.0685 11.0841 13.3483 11.2 13.64 11.2Z"
      fill="transparent"
      stroke="currentColor"
    />
    <Path
      d="M11 15.22C11 14.5172 11.2792 13.8431 11.7762 13.3462C12.2731 12.8492 12.9472 12.57 13.65 12.57C14.3528 12.57 15.0269 12.8492 15.5238 13.3462C16.0208 13.8431 16.3 14.5172 16.3 15.22"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M6.21129 17.4C5.76444 14.6764 5.62902 13.8565 5.80775 11.1"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M6.50001 4.79999H4.8C3.80589 4.79999 3 5.60588 3 6.59999V6.59999C3 7.5941 3.80589 8.39999 4.8 8.39999H8.40001"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.7 13.8H4.8C3.80589 13.8 3 14.6059 3 15.6V15.6C3 16.5941 3.80589 17.4 4.8 17.4H8.40001"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.95361 8.04003C6.03089 7.28447 6.13394 6.52892 6.25415 5.78225C6.37863 5.25842 6.63365 4.77754 6.99376 4.3876C7.35387 3.99767 7.80647 3.71232 8.3064 3.56004C11.6454 2.81332 15.0999 2.81332 18.4388 3.56004C18.9388 3.71232 19.3914 3.99767 19.7515 4.3876C20.1116 4.77754 20.3666 5.25842 20.4911 5.78225C21.1694 9.90068 21.1694 14.1082 20.4911 18.2267C20.3661 18.7493 20.1107 19.2287 19.7506 19.6171C19.3905 20.0055 18.9381 20.2893 18.4388 20.44C15.0999 21.1867 11.6454 21.1867 8.3064 20.44C7.98101 20.3466 7.67657 20.1969 7.40464 19.9999"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default BeneficiaryList;
